<template>
  <div class="material-paragraph-card" @click="detail">
    <div class="title left">
      <p><span>标题:</span> {{ item.title }}</p>
    </div>
    <div class="info left" v-html="item.content"></div>
    <div class="bottom clear">
      <div class="source fl">
        <!-- <span class="mr5">{{ item.source }}</span> -->
        <span class="mr5">在</span>
        <span>{{ item.issueTime }} 收藏</span>
      </div>

      <div class="tags fl">
        <span>标签:</span>
        <template v-if="item.labelNameList">
          <span
            @click.stop="deleteTag(tag)"
            class="ml5 label"
            v-for="tag in item.labelNameList.split('|')"
            :key="tag"
            >{{ tag }}
            <img
              src="../../../assets/image/document/whitedelete.png"
              width="13"
              height="13"
            />
          </span>
        </template>
        <span @click.stop="add" class="iconfont ml5 add">&#xe74a;</span>
      </div>

      <!-- <div class="fr">
        <span class="cancel" @click.stop="cancel"
          ><span class="iconfont ">&#xe60e;</span> 取消收藏</span
        >
      </div> -->
      <div class="fr labelcollect" @click.stop="cancel">
        <div class="icon"></div>
        <div class="text">取消收藏</div>
      </div>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    ...mapState("material", ["tags"])
  },
  methods: {
    ...mapActions("material", [
      "ALabelBind",
      "AFavoriteParagraphDel",
      "ALabel"
    ]),
    ...mapMutations("material", [
      "ASetDialogTagVisible",
      "AsetDetailPop",
      "AsetTagData",
      "AsetTags"
    ]),
    async cancel() {
      var result = await this.AFavoriteParagraphDel({
        favoriteParagraphIdList: this.item.favoriteParagraphId
      });
      if (result.errorCode == 0) {
        this.$message({
          showClose: true,
          message: "取消成功",
          type: "success"
        });
        this.$emit("getList", 1);
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    },
    add() {
      this.ASetDialogTagVisible({
        dialogTagVisible: true,
        detailLableNameList: this.item.labelNameList,
        detailTag: this.item.labelNameList,
        detailId: this.item.favoriteParagraphId
      });
    },
    async deleteTag(tag) {
      // var labelNameList = this.item.labelNameList;
      // var labelResult = this.item.labelNameList.split("|");
      var result = this.tags.filter(m => {
        return this.item.labelNameList.split("|").includes(m.labelName);
      });
      var tagsResult = result.filter(m => {
        return m.labelName != tag;
      });

      var labelIdList = tagsResult.map(m => m.labelId);

      var bindResult = await this.ALabelBind({
        labelIdList: labelIdList.join("|"),
        dataID: this.item.favoriteParagraphId,
        dataType: "paragraph"
      });
      if (bindResult.errorCode === 0) {
        this.getTagList();
        // this.AsetTagData(tag);
        this.item.labelNameList = tagsResult.map(m => m.labelName).join("|");
      }
    },
    detail() {
      this.AsetDetailPop({
        isShowDetail: true,
        id: this.item.favoriteParagraphId,
        detailType: "paragraph"
      });
    },
    async getTagList() {
      var result = await this.ALabel();
      if (result.errorCode != 0) {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
        return;
      }

      if (result.data != null && result.data.dataSource.length > 0) {
        // result.data = this.sortKey(result.data, "statCount");
        result.data.dataSource.sort(this.sortdown("statCount"));
      }
      this.AsetTags(result.data);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/color";
@import "../../../assets/style/config";
@import "../../../assets/style/mixin";
//标题
.material-paragraph-card:hover {
  background-color: #e6eef9;
  cursor: pointer;
}
.material-paragraph-card {
  padding-right: 5px;
  .title {
    font-size: 12px;
    padding-top: 10px;
    color: @color999;
  }

  //内容
  .info {
    margin: 10px 0;
    line-height: 1.5em;
  }
  //底部
  .bottom {
    padding-bottom: 10px;
    font-size: 12px;
    color: @color999;
  }
  .bottom .tag {
    background-color: #f39117;
    padding: 0px 8px;
    border-radius: 10px;
    color: white;
  }

  .bottom .tag .delete {
    cursor: pointer;
    font-size: 12px;
  }
  .bottom .add {
    color: #f39117;
    cursor: pointer;
    vertical-align: middle;
  }
  .bottom .cancel {
    color: #f39117;
    border: 1px solid #f39117;
    padding: 2px 10px;
    border-radius: 15px;
    cursor: pointer;
  }
  .bottom .tags {
    margin-left: 100px;
  }
  .bottom .source {
    color: @color999;
  }
}
</style>
<style lang="less">
.el-divider--horizontal {
  margin: 0px 0;
}
</style>
